import { render } from "./Sales.vue?vue&type=template&id=48e2b418&scoped=true"
import script from "./Sales.vue?vue&type=script&lang=js"
export * from "./Sales.vue?vue&type=script&lang=js"

import "./Sales.vue?vue&type=style&index=0&id=48e2b418&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e2b418"]])

export default __exports__